import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';

import AccessibleTextArea from '@bibliocommons/base-accessibility-text-area';
import { PrimaryButton } from '@bibliocommons/base-buttons';

export default function CommentableForm({ value, handleMessageChange, selectedCategory }) {
  return (
    <div>
      <div className="form-group">
        <label id="feedback-message-label" htmlFor="feedback-message" className="sr-only">
          <FormattedMessage id="feedback_comment_label" />
        </label>
        <AccessibleTextArea
          maxLength={4000}
          required
          value={value}
          id="feedback-message"
          labelledById="feedback-message-label"
          handleChange={handleMessageChange}
          handlePaste={handleMessageChange}
          rows="5"
          cols="60" />
      </div>

      <div className="text-right form-group">
        <PrimaryButton type="submit" disabled={selectedCategory === null}>
          <FormattedMessage id="button_submit" />
        </PrimaryButton>
      </div>
    </div>
  );
}

CommentableForm.propTypes = {
  selectedCategory: PropTypes.string,
  handleMessageChange: PropTypes.func.isRequired,
  value: PropTypes.string
};

CommentableForm.displayName = 'CommentableForm';



// WEBPACK FOOTER //
// ./app/components/feedback/category_forms/CommentableForm.jsx